import { useEffect, useState } from "react";
import { getCurrencyFlagEmoji, getCurrencyFlagUrl } from "../../../../utils/currency";
import "./CurrencyFlag.css";

export default function CurrencyFlag({ code, className = "" }) {
  const [failed, setFailed] = useState(false);
  const src = getCurrencyFlagUrl(code, 40);
  const src2x = getCurrencyFlagUrl(code, 80);
  const emoji = getCurrencyFlagEmoji(code);

  useEffect(() => {
    setFailed(false);
  }, [code]);

  if (!code) return null;

  if (!src || failed) {
    return emoji ? (
      <span className={`currency-flag currency-flag--emoji ${className}`.trim()} aria-hidden>
        {emoji}
      </span>
    ) : null;
  }

  return (
    <img
      className={`currency-flag ${className}`.trim()}
      src={src}
      srcSet={`${src2x} 2x`}
      alt=""
      width={28}
      height={21}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
